import { Typography, Box } from "@mui/material";

const EmptyData = ({ message, data }) => {
    return (
        <>
            {!data || data.length === 0 ? (
                <Box display="flex" justifyContent="center" alignItems="center" p={3}>
                    <Typography variant="body1" color="textSecondary">
                        {message || "No data found"}
                    </Typography>
                </Box>
            ) : null}
        </>
    );
};

export default EmptyData;
